export default {"src":"/login-app/[GIT_HASH]/_next/static/media/code_location_reload.f9964586.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};